<template>
    <header class="quoteTool__header">
        <div class="container">
            <h1>Quote and Buy Business Water Services Online</h1>
            <step-progress v-if="nav"></step-progress>
        </div>
    </header>
</template>

<script>
    import StepProgress from './StepProgress.vue';

    export default {
        components: {
            StepProgress,
        },

        props: {
            nav: {
                type: Boolean,
                required: false,
                default: true,
            }
        }
    }
</script>